import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=4237e468&scoped=true"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordModal.vue?vue&type=style&index=0&id=4237e468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4237e468",
  null
  
)

export default component.exports